export default __webpack_public_path__ + "locales/sl/InviteDialog.json?hash=fd11b5e1d62bfc6de298694a56731865";